import {
  Card,
  Carousel,
  ECardBorderRadiusSize,
  ECardMediaSize,
  ETextStyleVariant,
  Text,
} from '@outdoorsyco/bonfire';
import NextLink from 'next/link';
import React from 'react';
import { useIntl } from 'react-intl';

import defaultCampgroundImage from '@/assets/campgrounds-integration/fall-lake.jpg';
import {
  INearbyCampgroundsRaw,
  refineNearbyCampground,
} from '@/components/route/campground/campgroundTypes';
import { useBreakpoint } from '@/hooks/useBreakpoint';

type TNearbyCampgroundsProps = {
  campgrounds?: INearbyCampgroundsRaw[];
};

export const NearbyCampgrounds = ({ campgrounds }: TNearbyCampgroundsProps) => {
  const intl = useIntl();

  const { isMobile, isAboveDesktop } = useBreakpoint();

  if (!campgrounds?.length || !campgrounds?.filter(refineNearbyCampground).length) return null;

  return (
    <Carousel
      content={campgrounds
        // make sure the campgrounds we link to have enough information populated
        .filter(refineNearbyCampground)
        .map(campground => {
          return (
            <NextLink key={campground.id} href={campground.url} passHref legacyBehavior>
              <Card borderRadiusSize={ECardBorderRadiusSize.Large} withBoxShadow={false}>
                <Card.Media
                  image={defaultCampgroundImage.src}
                  size={ECardMediaSize.Medium}
                  fullRadius
                />
                <Card.Content>
                  <Text variant={ETextStyleVariant.LargeBold} className="mt-4">
                    {campground.title}
                  </Text>

                  <Text variant={ETextStyleVariant.MediumRegular} className="mt-2">
                    {intl.formatMessage(
                      { defaultMessage: 'Campground in {location}', id: 'rltDTf' },
                      { location: campground.parent_title },
                    )}
                  </Text>
                </Card.Content>
              </Card>
            </NextLink>
          );
        })}
      slidesPerGroup={1}
      slidesPerView={isMobile ? 1.2 : isAboveDesktop ? 4 : 3}
      autoHideNavigationArrows
      title={intl.formatMessage({
        defaultMessage: 'Similar nearby campgrounds',
        id: 'm55W2J',
      })}
    />
  );
};
